var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    fill: "#F8F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#FAFBFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_72261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 28,
    height: 29
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_72261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7526 23.4375L31.7153 25.4454C31.6062 25.5547 31.4735 25.6142 31.3172 25.6239C31.1609 25.6336 31.0184 25.5741 30.8899 25.4454C30.7656 25.3213 30.7035 25.1837 30.7035 25.0327C30.7035 24.8816 30.7656 24.744 30.8899 24.62L32.9202 22.5827L30.8899 20.5745C30.7656 20.4655 30.7035 20.3327 30.7035 20.1764C30.7035 20.0201 30.7656 19.8777 30.8899 19.7491C31.0184 19.6204 31.1572 19.556 31.3061 19.556C31.4549 19.556 31.5935 19.6204 31.722 19.7491L33.7526 21.7794L35.7607 19.7424C35.8698 19.6137 36.0025 19.5493 36.1589 19.5493C36.3152 19.5493 36.4576 19.6137 36.5861 19.7424C36.7149 19.8709 36.7792 20.0096 36.7792 20.1583C36.7792 20.3073 36.7149 20.446 36.5861 20.5745L34.5783 22.5827L36.5929 24.62C36.7066 24.7335 36.7661 24.8674 36.7714 25.0216C36.7766 25.1756 36.7149 25.3168 36.5861 25.4454C36.4576 25.5696 36.3201 25.6328 36.1734 25.635C36.0268 25.6373 35.8893 25.5741 35.7607 25.4454L33.7526 23.4375ZM21.5026 24.7812C20.5333 24.7812 19.7077 24.4403 19.0258 23.7584C18.3437 23.0763 18.0026 22.2506 18.0026 21.2812C18.0026 20.3121 18.3437 19.4865 19.0258 18.8044C19.7077 18.1223 20.5333 17.7812 21.5026 17.7812C22.4719 17.7812 23.2975 18.1223 23.9794 18.8044C24.6615 19.4865 25.0026 20.3121 25.0026 21.2812C25.0026 22.2506 24.6615 23.0763 23.9794 23.7584C23.2975 24.4403 22.4719 24.7812 21.5026 24.7812ZM13.3359 32.0058V31.2968C13.3359 30.8152 13.4761 30.3645 13.7565 29.9449C14.0371 29.5255 14.4144 29.1998 14.8885 28.9678C15.9894 28.4399 17.091 28.0439 18.1934 27.7799C19.2957 27.516 20.3987 27.3841 21.5026 27.3841C22.6065 27.3841 23.7095 27.516 24.8119 27.7799C25.9142 28.0439 27.0158 28.4399 28.1167 28.9678C28.5908 29.1998 28.9681 29.5255 29.2487 29.9449C29.5291 30.3645 29.6693 30.8152 29.6693 31.2968V32.0058C29.6693 32.3482 29.553 32.6357 29.3204 32.8683C29.0879 33.101 28.8003 33.2174 28.4577 33.2174H14.5475C14.2049 33.2174 13.9173 33.101 13.6848 32.8683C13.4522 32.6357 13.3359 32.3482 13.3359 32.0058Z",
    fill: "#E73C3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateModalIcon);
export default __webpack_public_path__ + "static/media/deactivateModalIcon.10f16da4389e432b46208e37ee237e1a.svg";
export { ForwardRef as ReactComponent };